export default {
  STATUSES: {
    open: { description: 'Abierto', initials: 'O' },
    pending_err: { description: 'Pendiente decisión - Departamento ERR', initials: 'PD-ERR' },
    pending_edb: { description: 'Pendiente decisión - Empresa de bus', initials: 'PD-EB' },
    pending_info: { description: 'Pendiente decisión - Pedir más información del cliente', initials: 'PD-MI' },
    pending_requested: { description: 'Pendiente decisión - Información adicional solicitada', initials: 'PD-IAS' },
    approved_communication: { description: 'Aprobado - Pendiente comunicación al cliente', initials: 'A-PCC' },
    approved_bank: { description: 'Aprobado - Pendiente envio de datos bancarios por parte del cliente', initials: 'A-PDB' },
    rejected_communication: { description: 'Rechazado - Pendiente comunicación al cliente', initials: 'R-PCC' },
    approved_reimbursement: { description: 'Aprobado - Pendiente devolución', initials: 'A-PD' },
    edb_accepted: { description: 'Aprobado por Empresa de bus', initials: 'A-EDB' },
    edb_rejected: { description: 'Rechazado por Empresa de bus', initials: 'R-EDB' },
    edb_request: { description: 'Pendiente decisión - Empresa de bus solicita información adicional', initials: 'PD-EBI' },
    rejected: { description: 'Resuelto - Rechazado', initials: 'R-R' },
    closed: { description: 'Resuelto', initials: 'R' },
    reimbursement_error: { description: 'Aprobado - Error en transferencia', initials: 'A-ET' },
    expired: { description: 'Expirado', initials: 'E' },
    approved_processing: { description: 'Aprobado - En proceso de devolución', initials: 'A-EPD' },
  },
  STATUSES_ECOMMERCE: {
    open: { description: 'Abierto', initials: 'O' },
    pending_ecommerce: { description: 'Pendiente decisión - Ecommerce', initials: 'PD-ECC' },
    refunded_ecommerce: { description: 'Reembolsado - Ecommerce', initials: 'RF-ECC' },
    rejected_ecommerce: { description: 'Rechazado - Ecommerce', initials: 'RJ-ECC' },
  },
  ACTIONS: {
    complaint_close: { description: 'cerró' },
    complaint_approve: { description: 'aprobó' },
    complaint_reject: { description: 'rechazó' },
    complaint_create: { description: 'creó' },
    complaint_comment: { description: 'comentó en' },
    complaint_update: { description: 'actualizó' },
    complaint_err_request: { description: 'solicitó información adicional sobre' },
    complaint_add_info: { description: 'adjuntó información en' },
    complaint_send_edb: { description: 'envió a compañía de bus' },
    complaint_reimburse: { description: 'realizó devolución de dinero' },
    complaint_crm_request: { description: 'solicitó información adicional del cliente sobre' },
    complaint_crm_info: { description: 'ingresó información adicional del cliente' },
    complaint_notify_rejection: { description: 'informó rechazo al cliente' },
    complaint_notify_approval: { description: 'comunicó aprobación (no monetaria) al cliente' },
    complaint_edb_approve: { description: 'aprobó' },
    complaint_edb_reject: { description: 'rechazó' },
    complaint_edb_request: { description: 'solicitó información adicional' },
    complaint_reimbursement_error: { description: 'notificó error en transferencia' },
    refund_method_changed: { description: 'cambió método de reembolso en' },
    error_method_changing: { description: 'falló cambio de método de reembolso' },
    complaint_ecommerce_rejected: { description: 'rechazó' },
    complaint_ecommerce_refunded: { description: 'reembolsó' },
  },
  BANKS: [
    ...(location.host.split('.').pop() === 'pe' && ['Banco de Comercio', 'Banco de Crédito del Perú', 'Banco Interamericano de Finanzas (BanBif)', 'Banco Pichincha', 'BBVA',
      'Citibank Perú', 'Interbank', 'MiBanco', 'Scotiabank Perú', 'Banco GNB Perú', 'Banco Falabella', 'Banco Ripley',
      'Banco Santander Perú', 'Alfin Banco', 'Bank of China', 'Bci Perú', 'ICBC PERU BANK']),
    ...(['cl', 'mx'].includes(location.host.split('.').pop()) && ['BANCO DE CHILE', 'BANCO EDWARDS', 'CITIBANK', 'BANCO ESTADO', 'SCOTIABANK', 'BBVA', 'BANCO CREDITO E INVERSIONES (BCI)',
      'CORPBANCA', 'BANCO BICE', 'BANCO SANTANDER', 'BANCO ITAU', 'ABN AMOR BANK', 'BANCO SECURITY', 'BANCO FALABELLA', 'BANCO CONSORCIO',
      'COOPEUCH', 'THE BANK OF TOKYO MITSUBISHI', 'BANCO SUD AMERICANO', 'BANCO DESARROLLO']),
  ],
  ACCOUNTS: [
    { code: 0, description: 'Cuenta Vista' },
    { code: 1, description: 'Cuenta Corriente' },
    { code: 2, description: 'Cuenta Ahorro' },
  ],
  ROLES: {
    1: { name: '🤖' },
    2: { name: 'CRM' },
    3: { name: 'ERR' },
    4: { name: 'EDB' },
    5: { name: 'FIN' },
  },
  DOCUMENTS: [
    'DNI', 'RUC', 'Carnet de extranjero', 'Pasaporte',
  ],
  PAYMENT_METHODS: [
    'WebPay', 'Agencia', 'Payu Crédito/Débito', 'Payu Pago Efectivo', '100% Cupones', 'Fintoc', 'OneClick',
    'Mercado Pago', 'Floid',
  ],
  REFUND_METHODS: [
    { code: 'payroll_paypal', description: 'Nómina PayPal' },
  ],
  REFUND_METHOD_TARGETS: {
    payroll_bank: 'payroll_paypal',
    devolution_tbk: 'payroll_paypal',
    devolution_fintoc: 'payroll_paypal',
    devolution_mercado_pago: 'payroll_paypal',
    devolution_floid: 'payroll_paypal',
  },
  COMMENT_TEMPLATES: [
    { title: 'Suspensión',
      template: 'Lo/a contactamos para notificar que el servicio del día [Fecha] a las [Hora] fue suspendido por la ' +
                'empresa de bus. En función de lo anterior, le ofrecemos el 100% del valor de sus pasajes. AVISO: A ' +
                'su correo electrónico llegará un mensaje de recordatorio de su viaje original, por favor ignorar, ' +
                'su viaje se encuentra suspendido. Por favor acusar recibo de la información.' },
    { title: 'Solicitud empresa de bus / Otros',
      template: 'Hemos resuelto en conjunto con la empresa de bus, devolver el [XX]% del valor de su pasaje. Pronto ' +
                'le notificaremos una vez que su reembolso entre en proceso. Lamentamos los inconvenientes.' },
  ],
};



// WEBPACK FOOTER //
// ./src/constants/Status.constants.js